import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { observer } from 'mobx-react-lite';
import { IMaskInput } from 'react-imask';
import _ from 'lodash';
import FieldWrapper from '../_components/FieldWrapper';
import { useFieldWrapper, } from '../_components/FieldWrapper.hooks';
const Input = forwardRef((props, ref) => {
    const { type = 'text', maxLength, mask } = props;
    const FW = useFieldWrapper(Object.assign(Object.assign({}, props), { clearedValue: '' }), ref);
    if ((mask === null || mask === void 0 ? void 0 : mask.mask) === 'number') {
        mask.mask = Number;
    }
    return (_jsxs(FieldWrapper, Object.assign({ element: 'input', props: FW }, { children: [mask ? (_jsx(_Fragment, { children: _jsx(IMaskInput, Object.assign({ inputRef: (el) => (FW.originalFieldRef.current = el), id: FW.id.toString(), type: type, value: String(FW.value), onAccept: (value, masked) => {
                        if (mask.onOutput) {
                            value = mask.onOutput(value, masked);
                        }
                        FW.onChange(value);
                    }, 
                    //
                    overwrite: "shift", radix: "." }, _.omit(mask, 'onOutput'), { 
                    //
                    maxLength: maxLength, readOnly: FW.readonly, disabled: FW.disabled, placeholder: FW.placeholder, 
                    // @ts-ignore
                    onFocus: FW.onFocus, 
                    // @ts-ignore
                    onBlur: FW.onBlur, 
                    // @ts-ignore
                    onKeyDown: FW.onKeyDown, autoFocus: FW.autoFocus })) })) : (_jsx("input", { ref: FW.originalFieldRef, id: FW.id.toString(), type: type, value: FW.value, onChange: (e) => FW.onChange(e.target.value), 
                //
                readOnly: FW.readonly, disabled: FW.disabled, placeholder: FW.placeholder, maxLength: maxLength, onFocus: FW.onFocus, onBlur: FW.onBlur, onKeyDown: FW.onKeyDown, autoFocus: FW.autoFocus })), props.children] })));
});
export default observer(Input);
